import { User } from './transflo-top-nav.component';
import {
  CommandCenterIconComponent,
  ConfirmationViewerIconComponent,
  CustomerManagementIconComponent,
  LocalIconComponent,
  PeopleManagementIconComponent,
  TransfloMobilePlusIconComponent,
  WorkflowAiIconComponent,
  WorkflowStudioIconComponent,
  UnknownAppComponent,
} from './icons';

export const ApplicationEnum = {
  PeopleManagement: 'PEOPLE_MANAGEMENT',
  WorkflowAi: 'WORKFLOW_AI',
  CustomerManagement: 'CUSTOMER_MANAGEMENT',
  WorkflowStudio: 'WORKFLOW_STUDIO',
  WorkflowAiLocal: 'WORKFLOW_AI_LOCAL',
  WorkflowStudioLocal: 'WORKFLOW_STUDIO_LOCAL',
  CommandCenterVelocityPlus: 'COMMAND_CENTER_VELOCITY_PLUS',
  ConfirmationViewer: 'CONFIRMATION_VIEWER',
  TransfloMobilePlusAdminPortal: 'TRANSFLO_MOBILE_PLUS_ADMIN_PORTAL',
} as const;

export type ApplicationEnumValues =
  (typeof ApplicationEnum)[keyof typeof ApplicationEnum];

export type ApplicationData = NonNullable<
  NonNullable<
    NonNullable<User['groups']>[number]['applications']
  >[number]['assignedApplication']
>;

export const getApplicationData: (
  appData: ApplicationData[],
  routerLinkOverrides?: Record<string, string>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (ApplicationData & { routerLink?: string; icon?: any })[] = (
  appData,
  routerLinkOverrides
) => {
  return appData.map(app => ({
    icon: applicationIconMap[app.name] || UnknownAppComponent,
    ...app,
    url: routerLinkOverrides?.[app.name] ? undefined : app.url,
    routerLink: routerLinkOverrides?.[app.name]
      ? routerLinkOverrides[app.name]
      : undefined,
  }));
};

// "applicationRoles = [ApplicationNAME:role, ApplicationNAME:role]"
export const deDuplicateApplication = (applicationRoles?: string) => {
  const appsAndRoles = parseApplicationRoles(applicationRoles);
  return Object.keys(appsAndRoles);
};

export const parseApplicationRoles = (applicationRoles?: string) => {
  const rolesAsStrings: string[] | undefined =
    JSON.parse(applicationRoles || '[]') || [];
  return (
    rolesAsStrings?.reduce<Partial<Record<ApplicationEnumValues, string[]>>>(
      (acc, cur) => {
        const appAndRole = cur.split(':');
        const appName = appAndRole[0] as ApplicationEnumValues | undefined;
        const role = appAndRole[1] as string | undefined;
        if (!appName || !role) return acc;
        if (!acc[appName]) {
          acc[appName] = [];
        }
        acc[appName].push(role);
        return acc;
      },
      {}
    ) || {}
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const applicationIconMap: Record<ApplicationEnumValues, any> = {
  [ApplicationEnum.WorkflowAi]: WorkflowAiIconComponent,
  [ApplicationEnum.PeopleManagement]: PeopleManagementIconComponent,
  [ApplicationEnum.CustomerManagement]: CustomerManagementIconComponent,
  [ApplicationEnum.WorkflowStudio]: WorkflowStudioIconComponent,
  [ApplicationEnum.WorkflowAiLocal]: LocalIconComponent,
  [ApplicationEnum.WorkflowStudioLocal]: LocalIconComponent,
  [ApplicationEnum.CommandCenterVelocityPlus]: CommandCenterIconComponent,
  [ApplicationEnum.TransfloMobilePlusAdminPortal]:
    TransfloMobilePlusIconComponent,
  [ApplicationEnum.ConfirmationViewer]: ConfirmationViewerIconComponent,
};

export const applicationNameMap: Record<ApplicationEnumValues, string> = {
  [ApplicationEnum.WorkflowAi]: 'Workflow AI',
  [ApplicationEnum.PeopleManagement]: 'People Management',
  [ApplicationEnum.CustomerManagement]: 'Customer Management',
  [ApplicationEnum.WorkflowStudio]: 'Workflow Studio',
  [ApplicationEnum.WorkflowAiLocal]: 'LOCAL wf ai',
  [ApplicationEnum.WorkflowStudioLocal]: 'LOCAL wf Studio',
  [ApplicationEnum.CommandCenterVelocityPlus]: 'Command Center',
  [ApplicationEnum.TransfloMobilePlusAdminPortal]:
    'Transflo Mobile+ Admin Portal',
  [ApplicationEnum.ConfirmationViewer]: 'Confirmation Viewer',
};
